import React from 'react';
import {Navigate, useParams} from "react-router-dom";
import LogoTransBlack from '../../Images/logoTransformationBlack.png';
import ThYouStylistImg from '../../Images/thankYouEstilistas.png';
import ThSubsImg from '../../Images/thankYouSubscriber.png';


const ThankYouPage = () => {

    const {type} = useParams();

    if (type == 'stylist' || type == 'subscriber') {
        return (
            <div className="container md:mt-16 md:mx-auto">
                <img className="p-8" src={LogoTransBlack} alt=""/>
                <div className="grid md:grid-cols-2 md:p-32 p-8">
                    <div className="flex flex-col justify-center items-center md:items-start text-center md:text-left space-y-6 mb-8">
                        <h1 className="font-medium text-4xl font-bold">¡Gracias por tu interes!</h1>
                        <p className="md:pr-48">{`Pronto recibirás información 
                           ${type == 'stylist' ? 'de cómo tu salón puede ser parte de Transformation.' :
                            'sobre novedades, oportunidades y más.'}`}
                        </p>
                        <a className="bg-black font-semibold text-white px-5 py-3 h-fit w-48" href="/transformation">VOLVER AL HOME</a>
                    </div>
                    <div>
                        <img src={type == 'stylist' ? ThYouStylistImg : ThSubsImg} alt=""/>
                    </div>
                </div>
            </div>
        );
    } else {
        return (<Navigate to="/transformation"/>);
    }

};

export default ThankYouPage;
